/**
 * Auth module — JWT storage, role guards, user info
 */

const JWT_KEY = "jwt";
const ROLE_KEY = "userRole";
const NAME_KEY = "userName";
const EMAIL_KEY = "userEmail";

// ─── Token ────────────────────────────────────────────────────────────────────
export function saveSession(
  token: string,
  role: string,
  name: string,
  email: string,
): void {
  localStorage.setItem(JWT_KEY, token);
  localStorage.setItem(ROLE_KEY, role);
  localStorage.setItem(NAME_KEY, name);
  localStorage.setItem(EMAIL_KEY, email);
}

export function clearSession(): void {
  [JWT_KEY, ROLE_KEY, NAME_KEY, EMAIL_KEY].forEach((k) =>
    localStorage.removeItem(k),
  );
}

export function getToken(): string | null {
  return localStorage.getItem(JWT_KEY);
}

export function getRole(): string | null {
  return localStorage.getItem(ROLE_KEY);
}

export function getUserName(): string {
  return localStorage.getItem(NAME_KEY) ?? "Usuario";
}

export function getUserEmail(): string {
  return localStorage.getItem(EMAIL_KEY) ?? "";
}

export function isLoggedIn(): boolean {
  const token = getToken();
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

// ─── Guards ───────────────────────────────────────────────────────────────────
/**
 * Redirect to login if not authenticated or wrong role.
 * Returns true if access is allowed.
 */
export function requireRole(role: "SuperAdmin" | "Client"): boolean {
  if (!isLoggedIn()) {
    window.location.href = "/index.html";
    return false;
  }
  const current = getRole();
  if (current !== role) {
    // Wrong role — redirect to correct portal
    if (current === "SuperAdmin") {
      window.location.href = "/admin.html";
    } else {
      window.location.href = "/portal.html";
    }
    return false;
  }
  return true;
}

// ─── Logout ───────────────────────────────────────────────────────────────────
export function logout(): void {
  clearSession();
  window.location.href = "/index.html";
}
